// Localize article category labels between IT and EN.
// Categories are stored as Italian strings in /app/backend/articles_data.py
// (Cultura, Cultura & Ricerca, Editoriale, Eventi, National Council, Progetto).
// We map them on the client so the backend stays single-source.

const CATEGORY_MAP = {
  it: {
    Cultura: "Cultura",
    "Cultura & Ricerca": "Cultura & Ricerca",
    Editoriale: "Editoriale",
    Eventi: "Eventi",
    "National Council": "National Council",
    Progetto: "Progetto",
  },
  en: {
    Cultura: "Culture",
    "Cultura & Ricerca": "Culture & Research",
    Editoriale: "Editorial",
    Eventi: "Events",
    "National Council": "National Council",
    Progetto: "Project",
  },
};

export function localizeCategory(category, lang = "it") {
  if (!category) return "";
  const dict = CATEGORY_MAP[lang] || CATEGORY_MAP.it;
  return dict[category] || category;
}
